import React from "react";
import g from "../utils/globals";

const Loading = () => (g.editMode ? <div>loading ...</div> : null);

export default Loading;
